// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e269949d","977":"d71040fc"}[chunkId] + ".chunk.js";
};